import React, { useEffect, useState } from "react";
import {
  Container,
  Typography,
  List,
  ListItem,
  ListItemText,
  Link,
  Paper,
  Box,
} from "@material-ui/core";
// import JsonViewer from "./JsonViewer";
import axios from "axios";
import JsonView from "@uiw/react-json-view";
import { uri } from "../../../../help/Api";
import { useTranslation } from "react-i18next";

// import { nordTheme } from "@uiw/react-json-view/nord";
// import { vscodeTheme } from "@uiw/react-json-view/vscode";
// import { darkTheme } from "@uiw/react-json-view/dark";
// import { vscodeTheme } from "@uiw/react-json-view/vscode";
const customTheme = {
  '--w-rjv-font-family': 'monospace',
  '--w-rjv-color': '#9cdcfe',
  '--w-rjv-key-string': '#9cdcfe',
  '--w-rjv-background-color': '#1e1e1e',
  '--w-rjv-line-color': '#36334280',
  '--w-rjv-arrow-color': '#838383',
  '--w-rjv-edit-color': 'var(--w-rjv-color)',
  '--w-rjv-info-color': '#9c9c9c7a',
  '--w-rjv-update-color': '#9cdcfe',
  '--w-rjv-copied-color': '#9cdcfe',
  '--w-rjv-copied-success-color': '#28a745',
  '--w-rjv-curlybraces-color': '#d4d4d4',
  '--w-rjv-colon-color': '#d4d4d4',
  '--w-rjv-brackets-color': '#d4d4d4',
  '--w-rjv-quotes-color': 'var(--w-rjv-key-string)',
  '--w-rjv-quotes-string-color': 'var(--w-rjv-type-string-color)',
  '--w-rjv-type-string-color': '#ce9178',
  '--w-rjv-type-int-color': '#b5cea8',
  '--w-rjv-type-float-color': '#b5cea8',
  '--w-rjv-type-bigint-color': '#b5cea8',
  '--w-rjv-type-boolean-color': '#569cd6',
  '--w-rjv-type-date-color': '#b5cea8',
  '--w-rjv-type-url-color': '#3b89cf',
  '--w-rjv-type-null-color': '#569cd6',
  '--w-rjv-type-nan-color': '#859900',
  '--w-rjv-type-undefined-color': '#569cd6'
};

const SectionLabel = ({ tile, discription }) => {
  return (
    <>
      <Typography
        style={{
          textAlign: "right",
          marginTop: "20px",
        }}
        variant="h4"
        component="h2"
        // gutterBottom={false}
      >
        {tile}
      </Typography>
      <hr style={{ paddingTop: "0px", marginTop: "0px" }} />
      <Typography
        style={{
          textAlign: "right",
        }}
        variant="h6"
        paragraph
      >
        {discription}
      </Typography>
    </>
  );
};
const README = () => {
  const { t } = useTranslation(["forms"]);
  const [jsonData, setJsonData] = useState({
    inv_data: {},
    headerFooterData: {},
    invoceItems: [],
  });
  const [fetching, setFetching] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      setFetching(true);
      await axios
        .get(`${uri}templates/demo`)
        .then((res) => {
          setJsonData(res?.data);
          setFetching(false);
        })
        .catch((err) => {
          console.log("errors");
          setFetching(false);
        });
    };
    fetchData();
  },[]);
  return (
    // <Container dir={"rtl"} style={{ textAlign: "right" }}>
    <>
      <>
        <SectionLabel
          tile={t("template-readme-overview")}
          discription={
            t("template-readme-overview-desc")
          }
        />
        <SectionLabel
          tile={t("template-readme-basic-steps")}
          discription={
            t("template-readme-basic-steps-desc")
          }
        />{" "}
        <Typography
          style={{
            textAlign: "right",
          }}
          variant="h6"
        >
          {t("template-readme-field-names")}
        </Typography>

        <SectionLabel
          tile={t("template-readme-header-footer-section")}
          discription={
            t("template-readme-header-footer-desc")
          }
        />
        <Paper
          elevation={1}
          style={{
            padding: "30px",
            backgroundColor: "#1e1e1eff",
            direction: "ltr",
          }}
          gutterBottom
        >
          {/* <JsonViewer /> */}
          <JsonView value={jsonData?.headerFooterData} style={customTheme}/>
          
        </Paper>
        <Typography
            style={{
              textAlign: "right",
            }}
            variant="h6"
          >
            {t("template-readme-foundation-note")}
          </Typography>
        <SectionLabel
          tile={t("template-readme-invoice-data")}
          discription={t("template-readme-invoice-data-desc")}
        />
        <Paper
          elevation={1}
          style={{
            padding: "30px",
            backgroundColor: "#1e1e1eff",
            direction: "ltr",
          }}
        >
          {/* <JsonViewer /> */}
          <JsonView value={jsonData?.inv_data} style={customTheme}
          // {vscodeTheme}
          />
        </Paper>
        <SectionLabel
          tile={t("template-readme-invoice-items")}
          discription={t("template-readme-invoice-items-desc")}
        />
        <Paper
          elevation={1}
          style={{
            padding: "30px",
            backgroundColor: "#1e1e1eff",
            direction: "ltr",
          }}
        >
          {/* <JsonViewer /> */}
          <JsonView value={jsonData?.invoceItems} style={customTheme}/>
        </Paper>
      
      </>
      {" "}
</>
  );
};

export default README;

